module.exports = __webpack_public_path__ + "img/itemico4.f4c4b682.png";